import eventTemplate from '@/domain/eventTemplate/routes'
import eventManage from '@/domain/eventManage/routes'
import faq from '@/domain/faq/routes'
import tag from '@/domain/tag/routes'
import shortener from '@/domain/shortener/routes'

import login from '@/domain/login/routes'
import role from '@/domain/roles/routes'
import contractManager from '@/domain/contract_manager/routes'
import eventOwner from '@/domain/event_owner/routes'
import collaborators from '@/domain/collaborators/routes'
import invoice from '@/domain/invoice/routes'
import verticalConfiguration from '@/domain/verticalConfiguration/routes'
import region from '@/domain/region/routes'
import priceListTemplate from '@/domain/priceListTemplate/routes'
import serviceOrders from '@/domain/serviceOrders/routes'
import nStats from '@/domain/stats/routes'
import customerSuccess from '@/domain/customerSuccess/routes'
import payout from '@/domain/payout/routes'
import adminPayout from '@/domain/adminPayout/routes'
import adminCertification from '@/domain/adminCertification/routes'
import emailTemplates from '@/domain/emailTemplates/routes'
import emailSchedules from '@/domain/emailSchedules/routes'
import refundType from '@/domain/refundType/routes'
import chargebackType from '@/domain/chargebackType/routes'
import accounting from '@/domain/accounting/routes'
import chargebacks from '@/domain/accounting/chargeback/routes'
// TODO: temporaneamente disabilitato
// import invitations from '@/domain/invitations/routes'

import dashboard from './_dashboard'
import reports from './_reports'
import utility from './_utility'

export default [
    ...dashboard,
    ...reports,
    ...eventTemplate,
    ...eventManage,
    ...faq,
    ...tag,
    ...shortener,

    ...login,
    ...role,
    ...contractManager,
    ...eventOwner,
    ...collaborators,
    ...invoice,
    ...verticalConfiguration,
    ...region,
    ...priceListTemplate,
    ...nStats,
    ...serviceOrders,
    ...customerSuccess,
    ...payout,
    ...adminPayout,
    ...adminCertification,
    ...emailTemplates,
    ...emailSchedules,
    ...refundType,
    ...chargebackType,
    ...accounting,
    ...chargebacks,
    // TODO: temporaneamente disabilitato
    // ...invitations,
    ...utility, // utility must be last since it contains the wildcard 404 route
]